import React from "react";
import "../App.scss";
import { verticals } from "../data/service";

const ServiceVertical = () => {
  return (
    <section className="verticals mb-8">
      <div className="row align-items-center no-gutters">
        {verticals.map((verticals) => (
          <div className="card-group mb-3" key={verticals.id}>
            <div className="col-md-4">
              <img
                className="verticals-image"
                src={verticals.image}
                alt="images"
              />
            </div>
            <div className="col-md-8">
              <div className="banner-text text-left">
                <div className="card-body">
                  <h4 className="card-title">{verticals.title}</h4>
                  <p className="card-text">{verticals.description}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceVertical;
